// extracted by mini-css-extract-plugin
module.exports = {"loader":"IconAdd_loader__2B_ns","root":"IconAdd_root__1Pqp3"};